import { HttpClient } from "@angular/common/http";
import { Injectable, NgZone } from "@angular/core";
import { Platform } from "@ionic/angular";
import { BackgroundGeolocation } from '@awesome-cordova-plugins/background-geolocation';
import { Geoposition, Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import * as main from "../../main";
import { Observable } from "rxjs";

@Injectable()
export class LocationProvider {

  // public watch: any;
  // public lat: number = 0;
  // public lng: number = 0;
  // public speed: number = 0;

  // public type: string = "null";
  // public maxSpeed: number = 0;
  // public sumDistance: number = 0;
  // public avgSpeed: number = 0;

  config = {
    backgroundGeoLocation: null,
    started: false,
    tempParams: null,
    lastPosition: null,
    lastOn: 0,
    callbackBag: [],
    fakeGeoLocation: null
  }

  constructor(
    public http: HttpClient,
    private platform: Platform,
    private zone: NgZone) { }

  test() {
    console.log('WE ARE IN LOCATION PROVIDER');
  }

  // initWithParams(succ, fail, conf) {
  //   console.log('initWithParams: ');
  //   var that = this;
  //   var sucFn = succ;

  //   this.backgroundGeo.configure(conf).subscribe((p) => {
  //     console.log('p: ', p);

  //     if (typeof p.positions === "undefined")
  //       this.updateLastPosition(p);
  //     else {
  //       this.updateLastPosition(p.positions[p.positions.lengt - 1] || this.config.lastPosition);
  //     }

  //     sucFn(p);

  //   });

  //   this.config.tempParams = ({ succ: succ, fail: fail, config: conf });
  // }

  // updateLastPosition(value) {
  //   this.config.lastPosition = value;
  //   this.onLocationChange();
  // }

  // onLocationChange() {
  //   // for (var i = 0; i < this.config.callbackBag.length; i++) {
  //   //     if (MyApp.Functions.isFunction(this.getCallbackBag()[i])) {
  //   //         this.getCallbackBag()[i](this.getLastPosition());
  //   //     }
  //   // }
  // }

  // finish() {
  //   BackgroundGeolocation.finish();
  // }

  // getPosition(): Promise<MyCoordination> {
  //   return new Promise<MyCoordination>((resolve, reject) => {
  //     if (this.lat != 0 && this.lng != 0)
  //       resolve({ lat: this.lat, lng: this.lng, date: new Date(), speed: this.speed });
  //   });
  // }

  // getCurrentPosition(): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     this.geolocation.getCurrentPosition().then(value => resolve(value));
  //   });
  // }

  // getType() {
  //   return this.type;
  // }

  // startTracking() {
  //   this.runForeground();

  //   // this.runForegroundHTML();

  //   this.runBackground();
  // }

  // runForegroundHTML() {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition((data) => {
  //       this.zone.run(() => {
  //         this.lat = data.coords.latitude;
  //         this.lng = data.coords.longitude;
  //         this.speed = data.coords.speed;
  //       });
  //     });
  //   } else {
  //     console.log("Geolocation is not supported by this browser.");
  //   }
  // }

  // runForeground() {

  //   // Foreground Tracking

  //   let options = {
  //     frequency: 500,
  //     enableHighAccuracy: true,
  //     maximumAge: 0
  //   };

  //   this.watch = this.geolocation.watchPosition(options).filter((p: any) => p.code === undefined).subscribe((position: Geoposition) => {
  //     console.log('position: ', position);

  //     // Run update inside of Angular's zone
  //     this.zone.run(() => {
  //       this.lat = position.coords.latitude;
  //       this.lng = position.coords.longitude;
  //       this.speed = position.coords.speed;

  //       this.type = "foreground";
  //     });

  //   });
  // }

  // runBackground() {

  //   // Background Tracking

  //   // High accuracy = 0
  //   // Medium accuracy = 10

  //   let config = {
  //     locationProvider: 0,
  //     stationaryRadius: 200,
  //     desiredAccuracy: 5,
  //     distanceFilter: 20,
  //     interval: 1000,
  //     fastestInterval: 1000,
  //     activitiesInterval: 1000,
  //     debug: false, //  enable this hear sounds for background-geolocation life-cycle.
  //     stopOnTerminate: true // enable this to clear background location settings when the app terminates
  //   };

  //   BackgroundGeolocation.configure(config);
  //   BackgroundGeolocation.on(BackgroundGeolocationEvents.location).subscribe((location) => {

  //     console.log('BackgroundGeolocation:  ' + location.latitude + ',' + location.longitude);

  //     // Run update inside of Angular's zone
  //     this.zone.run(() => {
  //       this.lat = location.latitude;
  //       this.lng = location.longitude;

  //       this.type = "background";
  //     });

  //     BackgroundGeolocation.start();
  //   });

  //   // Turn ON the background-geolocation system.
  // }

  // stopTracking() {
  //   BackgroundGeolocation.finish();
  //   this.watch.unsubscribe();

  // }

  getBgLoc(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.platform.ready().then(() => {
        //@ts-ignore
        resolve(BackgroundGeolocation);
      });
    });
  }

}

export interface MyCoordination {
  lat: number;
  lng: number;
  date: any;
  speed: number;
}
